module.exports = __webpack_public_path__ + "img/2017_innovation.daaec40f.jpg";